import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CurrencyTable from '../../components/CurrencyTable';

import './Dashboard.scss';
import bancaIntesa from './assets/banca-intesa.webp'
import raiffeisenBank from './assets/raiffeisen-bank.svg'
import DashboardAnalytics from "../../components/analytics/DashboardAnalytics";

const Dashboard = () => {
    const dispatch = useDispatch();
    const { data } = useSelector((state) => state.currencyData);

    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
        const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day
            .toString()
            .padStart(2, '0')}`;

        dispatch({ type: 'REQUEST_CURRENCY_DATA', payload: { date: formattedDate } });
    }, [dispatch]);

    return (
        <section className="dashboard-section">
            <div className="container mx-auto px-4 py-6">
                <DashboardAnalytics/>
                <br/>
                <br/>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Raiffeisen Section */}
                    <div className="text-center">
                        <img
                            src={raiffeisenBank}
                            alt="Raiffeisen"
                            className="mx-auto mb-4 h-16 object-contain max-w-200"
                        />
                        <CurrencyTable skipFields={['buyCash','sellCash','units', 'createdAtDate', 'id']} data={data} client="RAIFFEISEN" />
                    </div>

                    {/* Banca Intesa Section */}
                    <div className="text-center">
                        <img
                            src={bancaIntesa}
                            alt="Banca Intesa"
                            className="mx-auto mb-4 h-16 object-contain max-w-250"
                        />
                        <CurrencyTable skipFields={['buyCash','sellCash','units', 'createdAtDate', 'id']} data={data} client="BANCA_INTESA" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Dashboard;